import { formatMultiSelect } from "helpers/formatMultiSelect";
import PropTypes from "prop-types";
import React, { useMemo, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Spinner,
} from "reactstrap";

const HubMultiSelectFilterView = ({
  hubSelectOptions = [],
  selectedHubIds = [],
  onChange,
  label = "Hub",
  primary = true,
  isLoading = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const hubOptions = useMemo(
    () =>
      (hubSelectOptions || []).filter(
        optionItem => /^\d+$/.test(String(optionItem?.value || "").trim())
      ),
    [hubSelectOptions]
  );

  const summaryLabel = useMemo(() => {
    const labels = selectedHubIds.map(hubId => {
      const option = hubOptions.find(item => item.value === hubId);

      return option?.label || hubId;
    });

    return formatMultiSelect(labels);
  }, [selectedHubIds, hubOptions]);

  const handleToggleHub = hubId => {
    if (hubId === "all") {
      onChange(undefined);

      return;
    }

    const isChecked = selectedHubIds.includes(hubId);
    const nextHubIds = isChecked
      ? selectedHubIds.filter(item => item !== hubId)
      : [...selectedHubIds, hubId];

    onChange(nextHubIds.length ? nextHubIds : undefined);
  };

  const handleToggleDropdown = () => {
    if (isLoading) {
      return;
    }

    setIsOpen(prev => !prev);
  };

  return (
    <Dropdown
      className="d-inline-block align-middle mw-100"
      isOpen={isOpen}
      toggle={handleToggleDropdown}
    >
      <DropdownToggle
        className={`btn ${primary ? "primary-btn text-overflow" : ""} d-inline-flex align-items-center`}
        caret
        disabled={isLoading}
        style={{
          width: "fit-content",
          maxWidth: "min(420px, calc(100vw - 24px))",
          whiteSpace: "nowrap",
        }}
      >
        {label}
        <span
          style={{
            display: "inline-block",
            maxWidth: "min(220px, 55vw)",
            overflow: "hidden",
            textOverflow: "ellipsis",
            verticalAlign: "bottom",
          }}
        >
          :&nbsp;{isLoading ? "Đang tải..." : summaryLabel}
        </span>
        {isLoading ? <Spinner size="sm" className="ms-2" /> : null}
      </DropdownToggle>
      <DropdownMenu
        className="border shadow-sm"
        style={{
          width: "max-content",
          minWidth: "100%",
          maxWidth: "520px",
          maxHeight: 320,
          overflowX: "auto",
          overflowY: "auto",
          paddingTop: 6,
          paddingBottom: 6,
          scrollbarWidth: "thin",
          boxSizing: "border-box",
        }}
      >
        <DropdownItem
          toggle={false}
          className="px-3 py-2 text-dark font-weight-medium"
          style={{ cursor: "pointer", whiteSpace: "nowrap" }}
          onClick={() => handleToggleHub("all")}
        >
          Tất cả
        </DropdownItem>
        <DropdownItem divider />
        {hubOptions.map((item, index) => {
          const isChecked = selectedHubIds.includes(item.value);

          return (
            <DropdownItem
              toggle={false}
              key={`hub-multi-select-${item.value}-${index}`}
              className="d-flex align-items-center px-3 py-2 text-dark"
              style={{ cursor: "pointer", whiteSpace: "nowrap" }}
              onClick={() => handleToggleHub(item.value)}
            >
              <Input
                type="checkbox"
                className="form-check-input position-static flex-shrink-0 m-0"
                style={{
                  width: "1.125rem",
                  height: "1.125rem",
                  pointerEvents: "none",
                }}
                checked={isChecked}
                readOnly
                tabIndex={-1}
              />
              <span className="ms-2">{item.label}</span>
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};

HubMultiSelectFilterView.propTypes = {
  hubSelectOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  selectedHubIds: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  primary: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default HubMultiSelectFilterView;
